module.exports = __webpack_public_path__ + "d9b7a6ed7933731f8dff571efb20c9bc.png";